import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { View, Image, Dimensions, Alert } from 'react-native';
import { textStyle } from '../../../v2/theme/index.js';
import { PnmacText, PnmacSelect, PnmacTextInput, PnmacUIButton, PnmacRadioButtonGroup, PnmacRadioButton, HtmlToNativeNative } from 'pnmac-universal-components';
import { checkForAllNumbers, checkForAllNumbersWBetweenMinLengthAndMaxLength, testID, isEmptyOrSpaces } from '../../../utils.js';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../../../redux/events/events';
export default function AddBankAccountDetails(_a) {
  var disabled = _a.disabled,
    isOtp = _a.isOtp,
    translations = _a.translations,
    bankAccount = _a.bankAccount,
    onChange = _a.onChange,
    layout = _a.layout,
    matches = _a.matches,
    errors = _a.errors,
    setErrors = _a.setErrors,
    setCanSubmitted = _a.setCanSubmitted,
    canSubmitted = _a.canSubmitted,
    addBankAccountFunc = _a.addBankAccountFunc,
    onChangeBankAccountName = _a.onChangeBankAccountName,
    trackerDispatcher = _a.trackerDispatcher;
  var _b = React.useState({
      borrowerDetails: undefined,
      borrowersSelectList: []
    }),
    borrowers = _b[0],
    updateBorrowers = _b[1];
  var _c = React.useState({
      firstname: "",
      middleName: "",
      lastName: ""
    }),
    customerCustomName = _c[0],
    setCustomerCustomName = _c[1];
  var _d = React.useState(""),
    bankAccountSelectName = _d[0],
    setBankAccountSelectName = _d[1];
  var _e = React.useState(false),
    isNonBorrowerSelected = _e[0],
    setIsNonBorrowerSelected = _e[1];
  var _f = React.useState("yes"),
    useBorrowerName = _f[0],
    setUseBorrowerName = _f[1];
  var _g = React.useState(false),
    routingNumberError = _g[0],
    setRoutingNumberError = _g[1];
  var _h = React.useState(false),
    accountNumberError = _h[0],
    setAccountNumberError = _h[1];
  var _j = React.useState(false),
    confirmBankAccountError = _j[0],
    setConfirmBankAccountError = _j[1];
  React.useEffect(function () {
    var _a, _b, _c;
    var borrowersList = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.borrowerSummary) === null || _b === void 0 ? void 0 : _b.filter(function (borrower) {
      return borrower.loanId === (layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber);
    });
    var borrowersSelectList = (_c = borrowersList === null || borrowersList === void 0 ? void 0 : borrowersList.map(function (borrower) {
      return {
        key: borrower.borrowerId,
        label: "".concat(borrower.borrowerFirstName, " ").concat(borrower.borrowerMiddleName, " ").concat(borrower.borrowerLastName),
        value: borrower.borrowerUnparsedName
      };
    })) !== null && _c !== void 0 ? _c : [];
    borrowersSelectList.push({
      key: '-1',
      label: 'Non Borrower',
      value: '-1'
    });
    updateBorrowers({
      borrowersSelectList: borrowersSelectList,
      borrowerDetails: borrowersList
    });
  }, [layout]);
  var updateBorrowerName = function (value) {
    var _a, _b;
    var borrower = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.borrowerSummary) === null || _b === void 0 ? void 0 : _b.filter(function (borrower) {
      return borrower.loanId === (layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber);
    }).find(function (t) {
      return t.borrowerUnparsedName == value;
    });
    if (borrower) {
      onChangeBankAccountName({
        firstname: borrower.borrowerFirstName,
        middleName: borrower.borrowerMiddleName,
        lastName: borrower.borrowerLastName,
        bankAccountName: value
      });
    }
  };
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: {
      backgroundColor: '#fff',
      marginLeft: 10,
      marginRight: 10
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      backgroundColor: "#FFFFFF",
      display: "flex",
      flexDirection: matches.small ? "column" : "row",
      alignItems: "left",
      paddingTop: 10,
      paddingBottom: 10,
      borderBottomWidth: 1,
      borderBottomColor: "#e9e9e9",
      marginLeft: 20,
      marginRight: 20
    }
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 10,
      marginRight: 5,
      marginTop: matches.small ? 10 : undefined
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('SavingAccountsName'), {
    style: __assign(__assign({}, textStyle.formBody), {
      marginBottom: 10
    })
  }), translations.PaymentMethodsSavingAccountName), /*#__PURE__*/React.createElement(PnmacSelect, {
    nativeID: "txtBankAccountName",
    disabled: !isOtp && !disabled || (errors === null || errors === void 0 ? void 0 : errors.bankRoutingNumberError),
    useNativeAndroidPickerStyle: Platform.select({
      android: true,
      web: true,
      ios: true
    }),
    disabledColored: true,
    mode: "outlined",
    Icon: layout.mobile && Platform.OS === 'ios' ? function () {
      return /*#__PURE__*/React.createElement(Image, {
        style: {
          marginTop: 3,
          marginRight: 5,
          width: 12,
          height: 8
        },
        source: require("../../../assets/expand-icon.png")
      });
    } : function () {
      return null;
    },
    minLength: 1,
    maxLength: 22,
    value: bankAccountSelectName,
    style: {
      viewContainer: __assign({}, {
        width: Dimensions.get('window').width * 0.79,
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: "white",
        borderRadius: 10,
        height: 41,
        borderColor: '#707070',
        marginBottom: 15,
        borderWidth: 1
      }),
      inputAndroid: {
        color: "#707070",
        width: '100%',
        paddingLeft: 5,
        paddingRight: 5,
        borderRadius: 10,
        borderColor: '#707070',
        borderWidth: 1
      },
      inputIOS: {
        color: "#707070",
        paddingLeft: 5,
        paddingRight: 5,
        borderRadius: 10,
        borderColor: '#707070'
      }
    },
    items: borrowers === null || borrowers === void 0 ? void 0 : borrowers.borrowersSelectList,
    onValueChange: function (value) {
      if (value == -1) {
        setUseBorrowerName("no");
        setIsNonBorrowerSelected(true);
        setBankAccountSelectName(value);
        setCustomerCustomName({
          firstname: '',
          middleName: '',
          lastName: ''
        });
      } else if (isEmptyOrSpaces(value)) {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNameError: true
        }));
      } else {
        setIsNonBorrowerSelected(false);
        setUseBorrowerName("yes");
        setErrors(__assign(__assign({}, errors), {
          bankAccountNameError: false
        }));
        // onChange(value, "bankAccountName")
        updateBorrowerName(value);
        setBankAccountSelectName(value);
      }
    }
  }), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('BorrowerName'), {
    style: {
      fontFamily: "Halenoir Compact Regular",
      fontSize: 14,
      color: '#8B8B8B',
      marginBottom: 10
    }
  }), translations.PaymentMethodsSelectBorrowerName), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('FirstNameLastName'), {
    style: {
      fontFamily: "Halenoir Compact Regular",
      fontSize: 14,
      color: '#8B8B8B',
      marginBottom: 10
    }
  }), "Please enter your First Name, Middle Initial (if applicable) and Last Name exactly as it appears on your bank account to avoid delays in verifying the bank account and processing your payment."), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('NameMatchingBannerText'), {
    style: __assign(__assign({}, textStyle.formBody), {
      marginBottom: 10
    })
  }), "Does the name selected exactly match the name on the bank account you want to use for your payment?"), !isNonBorrowerSelected ? /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
    onValueChange: function (value) {
      setCustomerCustomName({
        firstname: '',
        middleName: '',
        lastName: ''
      });
      onChangeBankAccountName({
        firstname: "",
        middleName: "",
        lastName: "",
        bankAccountName: '-1'
      });
      setUseBorrowerName(value);
    },
    value: useBorrowerName
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      width: "20%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('NameMatchRadioYes'), {
    style: textStyle.formBody,
    idTag1: 'txtNachaYes'
  }), translations.yes)), /*#__PURE__*/React.createElement(PnmacRadioButton, {
    idTag1: 'rbnNachaYes',
    value: "yes"
  })), /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('NameMatchRadioNo'), {
    style: textStyle.formBody,
    idTag1: 'txtnNachaNo'
  }), translations.no)), /*#__PURE__*/React.createElement(PnmacRadioButton, {
    idTag1: 'rbnNachaNo',
    value: "no"
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null), useBorrowerName == "yes" ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(View, null, errors.nameOnBankAccountLengthError ? /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      color: 'red',
      paddingTop: 20,
      paddingBottom: 20
    }
  }, 'The name on the bank account should be less than 50 characters.') : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('BankAccountFirstNameText'), {
    style: __assign(__assign({}, textStyle.formBody), {
      marginBottom: 5
    })
  }), "First Name"), /*#__PURE__*/React.createElement(PnmacTextInput, __assign({}, testID('BankAccountFirstNameInput'), {
    left: true,
    textAlign: 'left',
    accessibilityLabel: "First Name",
    nativeID: "firstName",
    disabled: !isOtp && !disabled || useBorrowerName == "yes",
    name: "firstName",
    mode: "outlined",
    renderRightIcon: true,
    style: {
      width: '100%',
      height: 41,
      marginBottom: 5
    },
    value: customerCustomName === null || customerCustomName === void 0 ? void 0 : customerCustomName.firstname,
    isValid: customerCustomName.firstname.length > 0 && customerCustomName.firstname.length + customerCustomName.middleName.length + customerCustomName.lastName.length <= 50,
    error: isEmptyOrSpaces(customerCustomName.firstname) || customerCustomName.firstname.length + customerCustomName.middleName.length + customerCustomName.lastName.length > 50,
    onChangeText: function (text) {
      onChange(text, "bankAccountFirstName");
      setCustomerCustomName(__assign(__assign({}, customerCustomName), {
        firstname: text
      }));
    },
    onBlur: function () {
      if (customerCustomName) {
        if (isEmptyOrSpaces(customerCustomName === null || customerCustomName === void 0 ? void 0 : customerCustomName.firstname)) {
          setErrors(__assign(__assign({}, errors), {
            bankAccountNameError: true
          }));
        } else {
          setErrors(__assign(__assign({}, errors), {
            bankAccountNameError: false
          }));
        }
        if (customerCustomName.firstname.length + customerCustomName.middleName.length + customerCustomName.lastName.length > 50) {
          setErrors(__assign(__assign({}, errors), {
            nameOnBankAccountLengthError: true
          }));
        } else {
          setErrors(__assign(__assign({}, errors), {
            nameOnBankAccountLengthError: false
          }));
        }
      }
    }
  })), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('BankAccountMiddleNameText'), {
    style: __assign(__assign({}, textStyle.formBody), {
      marginBottom: 10
    })
  }), "Middle Initial"), /*#__PURE__*/React.createElement(PnmacTextInput, __assign({}, testID('BankAccountMiddleNameInput'), {
    left: true,
    textAlign: 'left',
    accessibilityLabel: "Middle Name",
    nativeID: "middleName",
    disabled: !isOtp && !disabled || useBorrowerName == "yes",
    name: "middleName",
    maxLength: 1,
    mode: "outlined",
    style: {
      width: '100%',
      height: 41,
      marginBottom: 15,
      textAlign: 'left'
    },
    value: customerCustomName === null || customerCustomName === void 0 ? void 0 : customerCustomName.middleName,
    onChangeText: function (text) {
      onChange(text, "bankAccountMiddleName");
      setCustomerCustomName(__assign(__assign({}, customerCustomName), {
        middleName: text
      }));
    },
    onBlur: function () {
      if (isEmptyOrSpaces(customerCustomName.middleName)) {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNameError: true
        }));
      } else {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNameError: false
        }));
      }
      if (customerCustomName.firstname.length + customerCustomName.middleName.length + customerCustomName.lastName.length > 50) {
        setErrors(__assign(__assign({}, errors), {
          nameOnBankAccountLengthError: true
        }));
      } else {
        setErrors(__assign(__assign({}, errors), {
          nameOnBankAccountLengthError: false
        }));
      }
    }
  })), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('BankAccountLastName'), {
    style: __assign(__assign({}, textStyle.formBody), {
      marginBottom: 10
    })
  }), "Last Name"), /*#__PURE__*/React.createElement(PnmacTextInput, __assign({}, testID('BankAccountLAstNameInput'), {
    left: true,
    renderRightIcon: true,
    textAlign: 'left',
    accessibilityLabel: "Last Name",
    nativeID: "lastName",
    disabled: !isOtp && !disabled || useBorrowerName == "yes",
    name: "lastName",
    mode: "outlined",
    isValid: customerCustomName.lastName.length > 0 && customerCustomName.firstname.length + customerCustomName.middleName.length + customerCustomName.lastName.length <= 50,
    style: {
      width: '100%',
      height: 41,
      marginBottom: 15
    },
    value: customerCustomName === null || customerCustomName === void 0 ? void 0 : customerCustomName.lastName,
    error: isEmptyOrSpaces(customerCustomName.lastName) || customerCustomName.firstname.length + customerCustomName.middleName.length + customerCustomName.lastName.length > 50,
    onChangeText: function (text) {
      onChange(text, "bankAccountLastName");
      setCustomerCustomName(__assign(__assign({}, customerCustomName), {
        lastName: text
      }));
    },
    onBlur: function () {
      if (isEmptyOrSpaces(customerCustomName.lastName)) {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNameError: true
        }));
      } else {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNameError: false
        }));
      }
      if (customerCustomName.firstname.length + customerCustomName.middleName.length + customerCustomName.lastName.length > 50) {
        setErrors(__assign(__assign({}, errors), {
          nameOnBankAccountLengthError: true
        }));
      } else {
        setErrors(__assign(__assign({}, errors), {
          nameOnBankAccountLengthError: false
        }));
      }
    }
  })))), /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentAccountTypeText'), {
    style: __assign(__assign({}, textStyle.formBody), {
      marginBottom: 10
    })
  }), translations.PaymentMethodsAccountType), /*#__PURE__*/React.createElement(PnmacSelect, __assign({}, testID('PaymentAccountTypeSelect'), {
    useNativeAndroidPickerStyle: Platform.select({
      android: true,
      web: true,
      ios: true
    }),
    key: 'paymentSelect1',
    idTag1: 'dropDownDocType',
    idTag2: 'bankAccountType',
    Icon: layout.mobile && Platform.OS === 'ios' ? function () {
      return /*#__PURE__*/React.createElement(Image, {
        style: {
          marginTop: 3,
          width: 12,
          height: 8
        },
        source: require("../../../assets/expand-icon.png")
      });
    } : function () {
      return null;
    },
    onValueChange: function (value) {
      if ("Select an item..." == value) {
        setErrors(__assign(__assign({}, errors), {
          bankAccountTypeError: true
        }));
      } else {
        if (parseInt(value) > 0) {
          setErrors(__assign(__assign({}, errors), {
            bankAccountTypeError: false
          }));
          onChange(value, "bankAccountType");
        }
      }
    },
    style: {
      viewContainer: __assign({}, {
        width: Dimensions.get('window').width * 0.79,
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: "white",
        borderRadius: 10,
        height: 41,
        borderColor: '#707070',
        borderWidth: 1,
        marginBottom: 15
      }),
      inputAndroid: {
        color: "#707070",
        width: '100%',
        paddingLeft: 5,
        borderRadius: 10,
        borderColor: '#707070',
        borderWidth: 1
      },
      inputIOS: {
        color: "#707070",
        width: '100%',
        paddingLeft: 5,
        borderRadius: 10,
        borderColor: '#707070'
      }
    },
    value: parseInt(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountType) || '',
    items: [{
      key: "Checking",
      label: "Checking Account",
      value: 201286
    }, {
      key: "Saving",
      label: "Savings Account",
      value: 201287
    }]
  }))), /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentMethodRoutingNumberText'), {
    style: __assign(__assign({}, textStyle.formBody), {
      marginBottom: 10
    })
  }), translations.PaymentMethodsRoutingNumber), /*#__PURE__*/React.createElement(PnmacTextInput, __assign({}, testID('PaymentMethodRoutingNumberInput'), {
    left: true,
    renderRightIcon: true,
    textAlign: 'left',
    accessibilityLabel: "Routing number",
    style: {
      width: '100%',
      height: 41
    },
    nativeID: "txtBankRoutingNumber",
    disabled: !isOtp && !disabled,
    mode: "outlined",
    label: routingNumberError ? 'Please enter a valid 9 digit number' : '',
    error: routingNumberError,
    isValid: !routingNumberError && (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankRoutingNumber.length) === 9,
    name: "bankRoutingNumber",
    value: bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankRoutingNumber,
    maxLength: 9,
    onBlur: function () {
      if (isEmptyOrSpaces(bankAccount.bankRoutingNumber) || !checkForAllNumbers(bankAccount.bankRoutingNumber, 9)) {
        setErrors(__assign(__assign({}, errors), {
          bankRoutingNumberError: true
        }));
        setRoutingNumberError(true);
      } else if (checkForAllNumbers(bankAccount.bankRoutingNumber)) {
        setRoutingNumberError(false);
        onChange(bankAccount.bankRoutingNumber, "bankRoutingNumber");
        if (checkForAllNumbers(bankAccount.bankRoutingNumber, 9)) {
          // turn to POST
          fetch("".concat(layout.pennyHomeUrl, "api/payment/ValidateRoutingNumber?routingnumber=").concat(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankRoutingNumber), {
            method: 'POST',
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": "Bearer ".concat(layout.token)
            }
          }).then(function (res) {
            return res.json();
          }).then(function (isValidRoutingNumber) {
            if (isValidRoutingNumber) {
              setErrors(__assign(__assign({}, errors), {
                bankRoutingNumberError: false
              }));
            } else {
              setErrors(__assign(__assign({}, errors), {
                bankRoutingNumberError: true
              }));
              setRoutingNumberError(true);
            }
          });
        }
      } else {
        setErrors(__assign(__assign({}, errors), {
          bankRoutingNumberError: false
        }));
        setRoutingNumberError(false);
      }
    },
    onChangeText: function (text) {
      if (checkForAllNumbers(text)) {
        onChange(text, "bankRoutingNumber");
      }
    }
  }))), /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentMethodAccountNumberText'), {
    style: __assign(__assign({}, textStyle.formBody), {
      marginBottom: 10,
      paddingRight: 15
    })
  }), translations.PaymentMethodsAccountNumber), /*#__PURE__*/React.createElement(PnmacTextInput, __assign({}, testID('PaymentMethodAccountNumberInput'), {
    left: true,
    renderRightIcon: true,
    textAlign: 'left',
    nativeID: "txtBankAccountNumber",
    minLength: 5,
    maxLength: 17,
    style: {
      width: '100%',
      height: 41
    },
    name: "bankAccountNumber",
    mode: "outlined",
    error: accountNumberError,
    label: accountNumberError ? 'Please enter a valid 5-17 digit number' : '',
    value: bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber,
    onFocus: function () {
      if (!checkForAllNumbers(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber)) {
        onChange("", "bankAccountNumber");
      }
    },
    onChangeText: function (text) {
      if (checkForAllNumbers(text)) {
        onChange(text, "bankAccountNumber");
      }
    },
    onBlur: function () {
      if (isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber) || !checkForAllNumbersWBetweenMinLengthAndMaxLength(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber, 5, 17)) {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNumberError: true
        }));
        setAccountNumberError(true);
      } else if (!isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber) && (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber) != (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber)) {
        setErrors(__assign(__assign({}, errors), {
          confirmAccountNumberError: true
        }));
        setAccountNumberError(false);
      } else {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNumberError: false,
          confirmAccountNumberError: false
        }));
        setAccountNumberError(false);
      }
    }
  }))), /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentMethodConfirmAccountNumber'), {
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      marginBottom: 5,
      paddingRight: 15
    }),
    nativeID: "lblConfirmAccountNumber"
  }), translations.PaymentMethodsConfirmAccountNumber), /*#__PURE__*/React.createElement(PnmacTextInput, __assign({}, testID('PaymentMethodConfirmAccountNumberInput'), {
    leftw: true,
    renderRightIcon: true,
    textAlign: 'left',
    accessibilityLabel: "Confirm account number",
    nativeID: "txtConfirmAccountNumber",
    style: {
      width: '100%',
      height: 41
    },
    maxLength: 17,
    name: "confirmAccountNumber",
    mode: "outlined",
    error: confirmBankAccountError && (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber) !== (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber),
    label: confirmBankAccountError ? 'Must match bank account number above' : '',
    value: bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber,
    placeholder: translations === null || translations === void 0 ? void 0 : translations.confirmAccountNumber,
    disabled: !isOtp && !disabled,
    isValid: (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber.length) !== 0 && (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber) === (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber),
    onFocus: function () {
      if (!checkForAllNumbers(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber)) {
        onChange("", "confirmAccountNumber");
      }
    },
    onChangeText: function (text) {
      if (checkForAllNumbers(text)) {
        onChange(text, "confirmAccountNumber");
      }
    },
    onBlur: function () {
      if (isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber) || (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber) != (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber)) {
        setConfirmBankAccountError(true);
        setErrors(__assign(__assign({}, errors), {
          confirmAccountNumberError: true
        }));
      } else {
        setConfirmBankAccountError(false);
        setErrors(__assign(__assign({}, errors), {
          confirmAccountNumberError: false
        }));
      }
    }
  })), confirmBankAccountError && /*#__PURE__*/React.createElement(PnmacText, {
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      color: "#fc5350",
      marginBottom: 5
    })
  }, confirmBankAccountError)), /*#__PURE__*/React.createElement(View, {
    style: {
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "View details",
    source: require("./../../../assets/img-account.jpg")
  })))))), /*#__PURE__*/React.createElement(View, {
    style: {
      marginLeft: 10,
      marginRight: 10,
      marginTop: 10,
      backgroundColor: '#F0F9FC',
      borderColor: '#CBEAF5',
      borderWidth: 1,
      padding: 10
    }
  }, /*#__PURE__*/React.createElement(HtmlToNativeNative, {
    value: layout.language === 'en' ? "It may take up to <b>5 business days</b> to verify a new bank account. When counting business days, weekends and holidays are not included. Until the bank account information has been verified, your payment will remain in pending status. When successfully verified, your payment will be processed and applied to your loan (loan activity) with the effective date you selected and if your selected date is before the end of your grace period, you will not be charged a late fee." : "La verificaci\u00F3n de la nueva cuenta bancaria puede tardar hasta <b>5 d\u00EDas h\u00E1biles.</b> En el c\u00E1lculo de los d\u00EDas h\u00E1biles, no se incluyen los fines de semana ni los d\u00EDas festivos. Hasta no verificar la informaci\u00F3n de la cuenta bancaria, su pago permanecer\u00E1 en estado pendiente. Cuando se verifique con \u00E9xito, su pago se procesar\u00E1 y se aplicar\u00E1 a su pr\u00E9stamo (actividad de pr\u00E9stamo) con la fecha de vigencia que haya seleccionado y, si la fecha seleccionada es anterior al final de su per\u00EDodo de gracia, no se le cobrar\u00E1 ning\u00FAn cargo por retraso."
  })), /*#__PURE__*/React.createElement(View, {
    style: {
      marginLeft: 10,
      marginTop: 20,
      marginBottom: 50,
      marginRight: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({
    idTag1: 'btnFilter',
    mode: "contained"
  }, testID('SubmitPayment'), {
    style: {
      marginLeft: matches.small ? 0 : 10,
      marginRight: matches.small ? 0 : 20,
      minWidth: "40%",
      height: 47.4,
      justifyContent: 'center',
      textAlign: 'center'
    },
    disabled: isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankRoutingNumber) || !(parseInt(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber) > 0 || canSubmitted) || !(checkForAllNumbersWBetweenMinLengthAndMaxLength(bankAccount.bankAccountNumber, 5, 17) && bankAccount.bankAccountNumber != "") || !(checkForAllNumbersWBetweenMinLengthAndMaxLength(bankAccount.confirmAccountNumber, 5, 17) && bankAccount.confirmAccountNumber != "" && bankAccount.bankAccountNumber == bankAccount.confirmAccountNumber) || isEmptyOrSpaces(bankAccount.bankAccountType.toString()) || isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountFirstName) || isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountLastName) || layout.pennyWise || errors.bankRoutingNumberError,
    onPress: function () {
      var _a, _b;
      if (isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankRoutingNumber) || isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber) || isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber) || bankAccount.bankAccountNumber != bankAccount.confirmAccountNumber || isEmptyOrSpaces((_a = bankAccount.bankAccountType) === null || _a === void 0 ? void 0 : _a.toString()) || isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountFirstName) || isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountLastName)) {
        setErrors(__assign(__assign({}, errors), {
          bankRoutingNumberError: isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankRoutingNumber),
          bankAccountNumberError: isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber),
          confirmAccountNumberError: isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber) || (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountNumber) != (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.confirmAccountNumber),
          bankAccountTypeError: isEmptyOrSpaces((_b = bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountType) === null || _b === void 0 ? void 0 : _b.toString()),
          bankAccountNameError: isEmptyOrSpaces(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankAccountName)
        }));
      } else {
        if (useBorrowerName == "yes") {
          updateBorrowerName(bankAccountSelectName);
        }
        addBankAccountFunc();
        trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "AutoPay/New Account-Add payment method |Mobile", -1, "", false);
      }
    }
  }), translations.PaymentMethodsAddPaymentMethod)));
}